// angular
// 	.module("HeroPRO")
// 	.controller("PipelineController", PipelineController);

import _ from 'lodash';

import './spinner.scss';

/* @ngInject */
export default function PipelineController($scope, raSpinnerService) {
    // register should be true by default if not specified.
    if (!$scope.hasOwnProperty('register')) {
        $scope.register = true;
    } else {
        $scope.register = $scope.register.toLowerCase() !== 'false';
    }

    if (!$scope.hasOwnProperty('text')) {
        $scope.text = 'Loading';
    }

    // Declare a mini-API to hand off to our service so the service
    // doesn't have a direct reference to this directive's scope.
    const api = {
        name: $scope.name,
        group: $scope.group,
        show() {
            $scope.show = true;
        },
        hide() {
            $scope.show = false;
        },
        toggle() {
            $scope.show = !$scope.show;
        },
    };

    // Register this spinner with the spinner service.
    if ($scope.register === true) {
        raSpinnerService._register(api);
    }

    // If an onShow or onHide expression was provided, register a watcher
    // that will fire the relevant expression when show's value changes.
    if ($scope.onShow || $scope.onHide) {
        $scope.$watch('show', (show) => {
            if (show && $scope.onShow) {
                $scope.onShow({ raSpinnerService, spinnerApi: api });
            } else if (!show && $scope.onHide) {
                $scope.onHide({ raSpinnerService, spinnerApi: api });
            }
        });
    }

    // This spinner is good to go. Fire the onLoaded expression.
    if ($scope.onLoaded) {
        $scope.onLoaded({ raSpinnerService, spinnerApi: api });
    }
}



// WEBPACK FOOTER //
// ./src/app/common/spinner/spinnerController.js